import {useState} from "react";
import uuid4 from "uuid4";

const useEditableList = (initialItems) => {
    const [items, setItems] = useState(initialItems);

    const addItem = () => {
        setItems(prev => {
            const disabled = prev.map(item => ({...item, disabled: true}));
            return [...disabled, {id: uuid4(), value: "", disabled: false}];
        });
    };

    const removeItem = (id) => {
        setItems(prev => {
            if (prev.length <= 1) return prev;
            return prev.filter(item => item.id !== id);
        });
    };

    const editItem = (id) => {
        setItems(prev => prev.map(item => ({...item, disabled: id !== item.id})));
    };

    const changeItem = (id, value) => {
        setItems(prev => prev.map(item => item.id === id ? {...item, value} : item));
    };

    return {items, setItems, addItem, removeItem, editItem, changeItem};
};

export default useEditableList;
